import type { RootLocationFeatureToggles } from '../features/app-config/types';

import type { LandingPagePathProps } from './types';

export const getIsOverviewPageEnabled = (
  rootLocationFeatureToggles:
    | RootLocationFeatureToggles
    | Record<string, boolean>
    | undefined
) =>
  Boolean(
    rootLocationFeatureToggles?.templateChecklistFlow ||
      rootLocationFeatureToggles?.workorderChecklistFlow
  );
export const getIsChecklistPageEnabled = (
  rootLocationFeatureToggles:
    | RootLocationFeatureToggles
    | Record<string, boolean>
    | undefined
) =>
  Boolean(
    rootLocationFeatureToggles?.templateChecklistFlow ||
      rootLocationFeatureToggles?.workorderChecklistFlow
  );

export const getIsTemplatesPageEnabled = (
  rootLocationFeatureToggles:
    | RootLocationFeatureToggles
    | Record<string, boolean>
    | undefined
) => Boolean(rootLocationFeatureToggles?.templateChecklistFlow);

export const getIsObservationsPageEnabled = (
  rootLocationFeatureToggles:
    | RootLocationFeatureToggles
    | Record<string, boolean>
    | undefined
) =>
  Boolean(
    typeof rootLocationFeatureToggles?.observations !== 'boolean' &&
      rootLocationFeatureToggles?.observations?.isEnabled
  );

export const getRootContainer = () => document.getElementById('root');

export const getLandingPagePath = ({
  isChecklistPageEnabled,
  isDesktop,
  isIdm,
  isObservationsFeatureEnabledOnIdm,
  selectedRootLocation,
}: LandingPagePathProps): string => {
  if (isChecklistPageEnabled) {
    return '/checklists';
  }

  if (isDesktop) {
    if (isIdm) {
      if (isObservationsFeatureEnabledOnIdm) {
        return '/observations';
      }
      return '/application-configuration';
    }
    if (selectedRootLocation) {
      return `/asset/${selectedRootLocation.assetExternalId}`;
    }
  }

  return '/explore';
};
